import { AloftPrice, AloftPriceJSON, ManualAdjustments } from '@aloft/toolkit-shared';

const inputStringToPrice = (value: string): AloftPriceJSON => {
  // Apparently `parseFloat` doesn't like the minus sign and instead needs a hyphen
  const negativeCorrectedValue = value.replace('\u2212', '\u002d');
  const parsedValue = parseInt(negativeCorrectedValue, 10);
  const safeValue = Number.isNaN(parsedValue) ? 0 : parsedValue;

  return AloftPrice.fromDollarLike(safeValue).toJSON();
};

export const formManualAdjustmentsToState = (formManualAdjustments: {
  concessions: string;
  termsOfSale: string;
}): ManualAdjustments => ({
  concessions: inputStringToPrice(formManualAdjustments.concessions),
  termsOfSale: inputStringToPrice(formManualAdjustments.termsOfSale),
});
